import React, { useEffect, useState } from 'react'
import ClickOutHandler from 'react-onclickout'

import './styles.scss'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const AVProcessSelector = ({ currentProcessId, processes, isLoading, onChange }) => {
  const [selectedProcess, setSelectedProcess] = useState({})
  const [isOpenOptionsMenu, setIsOpenOptionsMenu] = useState(false)
  const [filteredProcess, setFilteredProcess] = useState(processes || [])
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    if (processes?.length) {
      const currentProcess = processes.find(({ processId }) => processId === currentProcessId)
      if (currentProcess) setSelectedProcess({ id: currentProcess.processId, name: currentProcess.processName })
      handleSearch()
    }
  }, [processes])

  const toggleOptionsMenu = () => setIsOpenOptionsMenu(!isOpenOptionsMenu)

  const handleSelectProcess = ({ id, name }) => {
    const process = { id, name }
    setSelectedProcess(process)
    onChange(process)
    toggleOptionsMenu()
  }

  const handleSearch = (value = '') =>  {
    let filteredProcess = []
    filteredProcess = processes.filter(process => process.processName.toLowerCase().includes(value.toLowerCase()))
    setSearchValue(value)
    setFilteredProcess(filteredProcess)
  }

  return (
    <div className='av-process-selector'>
      <div
        className='av-process-selector__content-container'
        onClick={() => !isLoading ? toggleOptionsMenu() : null}
      >
        <figure className='av-process-selector__icon'>
          <img src={getStaticImage('/icons/orange-brand/icon-play-secondary.svg')} alt='Process' />
        </figure>
        {!isLoading ? (
          <p
            title={selectedProcess.name || lang('dashboard_select')}
            className='av-process-selector__value-text text-ellipsis'
          >
            {selectedProcess.name || lang('dashboard_select')}
          </p>
        ) : (
          <Nixi1Spinner width='20px' height='20px' />
        )}
        <figure className='av-process-selector__icon av-process-selector__icon--arrow'>
          <img src={getStaticImage('/icons/orange-brand/icon-arrow-right-secondary.svg')} alt='Collapse' />
        </figure>
      </div>
      {isOpenOptionsMenu ? (
        <ClickOutHandler onClickOut={toggleOptionsMenu}>
          <ul className='av-process-selector__options-menu'>
            <li className='av-process-selector__search-container'>
              <figure>
                <img src={getStaticImage('/icons/orange-brand/icon-search-grey.svg')} alt='Search' />
              </figure>
              <input
                type='text'
                placeholder={lang('dashboard_search')}
                value={searchValue}
                onChange={({ target: { value } }) => handleSearch(value)}
              />
              {searchValue ? (
                <button onClick={() => handleSearch()}>
                  <figure>
                    <img src={getStaticImage('/icons/orange-brand/icon-close-slim-grey.svg')} alt='Clear' />
                  </figure>
                </button>
              ) : null}
            </li>
            {filteredProcess?.length ? (
              filteredProcess.map((process, index) => (
                <li
                  key={index}
                  onClick={() => handleSelectProcess({ id: process.processId, name: process.processName })}
                >
                  <p
                    title={process.processName}
                    className='text-ellipsis'
                  >
                    {process.processName}
                  </p>
                </li>
              ))
            ) : (
              <p className='av-process-selector__info-text'>{lang('chatbot_processes_notProcess')}</p>
            )}
          </ul>
        </ClickOutHandler>
      ) : null}
    </div>
  )
}

export default AVProcessSelector
